<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card elevation="4">
            <v-card-title class="text-subtitle-1">
                <v-icon small class="pr-2" >mdi-tag-outline</v-icon>
                Adicionar Distritos
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                >
                </v-text-field>

                <!-- <v-btn 
                    class="grey lighten-1 black--text"
                    rounded
                    elevation="0"
                    left
                    @click="close"
                ><v-icon small left>mdi-close-box-outline</v-icon>Fechar</v-btn> -->
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-data-table
                    dense
                    :headers="headersDistrictTable"
                    :items="listDistricts"
                    :search="search"
                    @click:row="rowSelected"
                    :hide-details="true"
                    :hide-default-footer="true"
                    class="row-pointer elevation-1"
                    disable-pagination
                    fixed-header
                    height="400"
                >
                </v-data-table>
                <!-- <p class="ma-2 text-sm-body-2">
                    <v-chip-group 
                        column 
                        multiple>
                        <v-chip
                            label
                            outlined
                            v-for="dst in listDistricts" :key="dst.DistritoId"
                            @click="addDistricts(dst.DistritoId, dst.DescricaoDistrito)">
                        {{ dst.DescricaoDistrito }}
                        </v-chip>
                    </v-chip-group>
                    
                </p> -->
             </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer/>
                <v-btn elevation="0"
                                color="secondary"
                                small
                                outlined
                                rounded  @click="close">
                    <v-icon small left>mdi-close</v-icon>
                    Fechar</v-btn>
            </v-card-actions>
            <snackbar
                :text="snackbarMessage"
                :color="snackbarColor"
                v-model="showSnackbarDistrict"
            />
        </v-card>
    </v-dialog>
</template>
<script>
import snackbarMixin from "@/mixins/snackbar.mixin";

export default {
    mixins: [snackbarMixin],
    props:{
        dialog:{
            default:false
        }
    },
    mounted() {},
    data(){
        return {
            listDistrictsSelected:[],
            listDistricts:[],
            showSnackbarDistrict: false,
            search: '',
            headersDistrictTable: [
                {
                    text: 'Distrito',
                    align: 'start',
                    sortable: true,
                    value: 'DescricaoDistrito',
                }
            ]
        }
    },
    methods: {
        close(){
            this.$emit('update:dialog', false)
        },
        addDistricts(id, text){
            let tagFind = this.listDistrictsSelected.map(e=>e.DistritoId).indexOf(id);

            if(tagFind == -1) {
                 this.listDistrictsSelected.push({DistritoId:id, DescricaoDistrito:text});
             } else {
                 this.showSnackbar('Item já adicionado!', 'error');
             }

        },
        loadDistricts(districts){
            this.listDistricts = districts;
        },        
        loadDistrictsRequest(item){
            //recebe os itens vindo da tela origem e atribui seu valor à variavel
            this.listDistrictsSelected = item;
        },
        rowSelected(value){
            if((value != null && value != undefined)
             && (value.DistritoId != undefined && value.DistritoId != null) 
             && (value.DescricaoDistrito != undefined && value.DescricaoDistrito != null))
             {
                 this.addDistricts(value.DistritoId, value.DescricaoDistrito);
            }else{
                this.showSnackbar('Nâo é possível a indicação do distrito.','error');
            }
        },
        clear(){}
    }

}
</script>
<style scoped>
    .row-pointer >>> tbody tr:hover {
        cursor: pointer;
    }
    #virtual-scroll-table {
    max-height: 400px;
    overflow: auto;
    }    
</style>